import React, { Fragment, useEffect, useState } from "react"; // @ts-ignore
import PageSectionContainer from "../common/page-section-container";
import PageSectionHeading from "../common/page-section-heading";
import SidebarItem from "../edition/sidebar-item";
import AuthorNames from "../author-names";
import { Link } from "gatsby";
import Icon, { IconName } from "../icon";
import Modal from "../common/modal";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../../tailwind.config";
import DOMWindow from "../../util/dom-wrapper/window";
import { StatusType } from "../../services/firebase/auth-context/reducer";
var SidebarContent = function SidebarContent(_ref) {
    var spotlight = _ref.spotlight, readArticles = _ref.readArticles;
    return /*#__PURE__*/ React.createElement("div", {
        className: "h-full overflow-auto w-full lg:block lg:w-1/3 lg:pr-4"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "bg-makroRustyLight pb-3"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: spotlight.topic,
        className: "mb-6"
    }), spotlight.articles.map(function (article, index) {
        return /*#__PURE__*/ React.createElement(SidebarItem, {
            key: index,
            to: "/spotlight/" + spotlight.slug + "/" + article.slug + "/",
            read: readArticles && readArticles.includes(article.id),
            title: article.title,
            className: "mb-10",
            articleId: article.id,
            visibility: article.visibility,
            isEdition: false
        }, /*#__PURE__*/ React.createElement(AuthorNames, {
            authors: article.authors,
            link: false
        }));
    })), /*#__PURE__*/ React.createElement(Link, {
        to: "/alle-spotlights/",
        className: "w-24 block relative mt-12 ml-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-0 right-0 font-bold text-center text-white z-20 leading-tight text-xs",
        style: {
            top: "21px",
            paddingRight: "20px"
        }
    }, "ALLE SPOTLIGHTS"), /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.MAGNIFIER,
        color: "#005C16"
    })));
};
var SpotlightSidebar = function SpotlightSidebar(_ref2) {
    var spotlight = _ref2.spotlight, authContext = _ref2.authContext;
    var _authContext$ = authContext[0], userData = _authContext$.userData, authenticated = _authContext$.authenticated;
    var _useState = useState(false), sidebarState = _useState[0], setSidebarState = _useState[1];
    useEffect(function () {
        var onResize = function onResize() {
            var cssFullConfig = resolveConfig(tailwindConfig);
            if (DOMWindow.innerWidth() >= parseInt(cssFullConfig.theme.screens.lg)) {
                setSidebarState(false);
            }
        };
        DOMWindow.addEventListener("resize", onResize);
        return function () {
            return DOMWindow.removeEventListener("resize", onResize);
        };
    }, []);
    var toggleSidebar = function toggleSidebar() {
        setSidebarState(!sidebarState);
    };
    var readArticles = authenticated && userData.status === StatusType.SUCCESS && userData.data.readArticles;
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: "fixed px-2 left-0 font-bold text-center text-sm text-white shadow-md rounded-b transform -rotate-90 z-30 bg-makroOrange lg:hidden",
        style: {
            top: "50%",
            width: "128px",
            height: "22px",
            marginTop: "-32px",
            marginLeft: "-54px"
        },
        onClick: toggleSidebar
    }, "Inhaltsverzeichnis"), /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:contents"
    }, /*#__PURE__*/ React.createElement(SidebarContent, {
        spotlight: spotlight,
        readArticles: readArticles
    })), /*#__PURE__*/ React.createElement(Modal, {
        isOpen: sidebarState,
        onRequestClose: toggleSidebar
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pr-10 pb-3"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "font-bold text-xl"
    }, spotlight.topic), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-600"
    }, "SPOTLIGHT ", spotlight.label)), /*#__PURE__*/ React.createElement(SidebarContent, {
        spotlight: spotlight,
        readArticles: readArticles
    })));
};
export default SpotlightSidebar;
